import { useCallback } from "react";
import type { OnboardingState } from "@shared-domain/unizo/contract";
import { useOptionalPreference } from "@/contexts/PreferencesContext";

/**
 * 初回オンボーディングの進み具合と出してよいか（PRODUCT_DEV-783）。
 *
 * 進み具合は本人の個人設定（ONBOARDING）に裏で覚える。画面に設定項目は出さない。
 */
export function useOnboarding() {
  const [saved, setSaved, resolved] = useOptionalPreference("onboarding");
  const state: OnboardingState = saved ?? {};

  /** 項目を足して丸ごと書く（差分マージはしない契約なので、いまの値に重ねてから書く）。 */
  const update = useCallback(
    (patch: Partial<OnboardingState>) => setSaved({ ...(saved ?? {}), ...patch }),
    [saved, setSaved],
  );

  const allDone = !!(state.step1 && state.step2 && state.step3);
  return {
    resolved,
    state,
    update,
    allDone,
    /** ホームに「はじめての方へ」を出すか（始めたが終わっていない・消していない）。 */
    showResumeCard: !allDone && !state.hidden && !!(state.autoShown || state.step1 || state.menuOpened),
    /** メニューの「はじめての方へ」と「メニュー」タブに赤ポチを出すか（1度開くまで）。 */
    showNewDot: resolved && !state.menuOpened,
  };
}
